// based on https://angular.io/guide/dynamic-component-loader
import { computed, Directive, inject, input, ViewContainerRef } from '@angular/core';

import { BarLayoutSection } from '../bar-layout-section.enum';

@Directive({
    selector: '[barLayoutAnchor]',
    standalone: true
})
/**
 * Anchor directive to inject components dynamically in the layout.
 */
export class _BarLayoutAnchorDirective {
    readonly viewContainerRef = inject(ViewContainerRef);

    readonly barLayoutAnchor = input<string>(undefined);

    readonly section = computed(() => {
        switch (this.barLayoutAnchor()) {
            case 'utilities':
                return BarLayoutSection.Utilities;
            case 'menu-action-bar-top-left':
                return BarLayoutSection.MenuActionBarTopLeft;
            case 'menu-action-bar-top-right':
                return BarLayoutSection.MenuActionBarTopRight;
            case 'action-bar-top-left':
                return BarLayoutSection.ActionBarTopLeft;
            case 'action-bar-top-right':
                return BarLayoutSection.ActionBarTopRight;
            case 'menu-top':
                return BarLayoutSection.MenuTop;
            case 'content-action-bar-top-right':
                return BarLayoutSection.ContentActionBarTopRight;
            case 'content-action-bar-bottom-right':
                return BarLayoutSection.ContentActionBarBottomRight;
            case 'menu-bottom':
                return BarLayoutSection.MenuBottom;
            case 'menu-action-bar-bottom-left':
                return BarLayoutSection.MenuActionBarBottomLeft;
            case 'menu-action-bar-bottom-right':
                return BarLayoutSection.MenuActionBarBottomRight;
            case 'action-bar-bottom-left':
                return BarLayoutSection.ActionBarBottomLeft;
            case 'action-bar-bottom-right':
                return BarLayoutSection.ActionBarBottomRight;
            case 'global-header-right':
                return BarLayoutSection.GlobalHeaderRight;
            default:
                return null;
        }
    });
}
